module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 14 14",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.9995 8.42913H0.57274C0.494168 8.42913 0.429883 8.49342 0.429883 8.57199V9.64342C0.429883 9.72199 0.494168 9.78627 0.57274 9.78627H11.3799L8.8031 13.0541C8.72988 13.147 8.79596 13.2863 8.9156 13.2863H10.2102C10.2977 13.2863 10.3799 13.247 10.4352 13.1773L13.4495 9.35413C13.7442 8.97913 13.4781 8.42913 12.9995 8.42913ZM13.4299 4.21484H2.62274L5.19953 0.946987C5.27274 0.854129 5.20667 0.714844 5.08703 0.714844H3.79238C3.70488 0.714844 3.62274 0.75413 3.56738 0.823772L0.553097 4.64699C0.258454 5.02199 0.524526 5.57199 1.00131 5.57199H13.4299C13.5085 5.57199 13.5727 5.5077 13.5727 5.42913V4.3577C13.5727 4.27913 13.5085 4.21484 13.4299 4.21484Z",
      "fill": "white"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e0dc1ec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/AssignIcon.vue
// module id = 1477
// module chunks = 159